<template>
  <v-container grid-list-md>
    <div class="pageTitle">経費管理</div>
    <v-expansion-panel v-model="panel" expand style="margin: 10px 0px">
      <v-expansion-panel-content>
        <template v-slot:header>
          <div class="title">表示条件</div>
        </template>
        <v-card>
          <v-card-text>
            <v-layout align-center justify-start row fill-height>
              <v-flex md2 class="search-label subheading">年月</v-flex>
              <v-flex md2>
                <v-select :items="years" v-model="year" suffix="年" />
              </v-flex>
              <v-flex md1>
                <v-select :items="months" v-model="month" suffix="月" />
              </v-flex>
            </v-layout>
            <v-layout align-center justify-start row fill-height>
              <v-flex md2 class="search-label subheading">チーム</v-flex>
              <v-flex md2 v-for="(team, i) in teams" :key="i">
                <v-checkbox
                  v-model="selectedTeams"
                  :label="team"
                  :value="team"
                  :disabled="CanI('ManageMyTeam')"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout align-center justify-start row fill-height>
              <v-flex md2 class="search-label subheading"
                >フリーワード *</v-flex
              >
              <v-flex md4>
                <v-text-field v-model="search"></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-dialog v-model="dialog" persistent max-width="80%">
      <read-timecard
        @closeDialog="dialog = false"
        v-model="selectedTimecard"
        v-if="dialog"
      />
    </v-dialog>
    <v-btn color="green" class="white--text" @click="downloadXlsxFile">
      <v-icon color="white">cloud_download</v-icon>ダウンロード
    </v-btn>
    <v-layout style="height: 500px; width: 100%">
      <div class="table-container scroll-bar">
        <v-data-table
          :headers="headers"
          :items="fillteredItems"
          class="elevation-1"
          :search="search"
          :pagination.sync="pagination"
          rows-per-page-text="表示行"
          :rows-per-page-items="rowsPerPageItems"
          style="width: 1150px"
        >
          <template v-slot:headers="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="{ sticky: true, 'column-fixed': header.text == '日' }"
              >
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <tr>
              <td></td>
              <td class="text-xs-left" :class="dayClass(props.item)">
                {{ props.item.month }}
              </td>
              <td class="text-xs-left" :class="dayClass(props.item)">
                {{ props.item.date }}
              </td>
              <td class="text-xs-left" :class="dayClass(props.item)">
                {{ toDay(props.item.day_number) }}
              </td>
              <td class="text-xs-left text-smaller">
                {{ props.item.staff_id }}
              </td>
              <td class="text-xs-left text-smaller">
                {{ props.item.owner_name }}
              </td>
              <td class="text-xs-left text-smaller">
                {{ props.item.owner_team }}
              </td>
              <td class="text-xs-left text-smaller">
                {{ props.item.client_id }}
              </td>
              <td class="text-xs-left text-smaller">
                {{ props.item.client_name }}
              </td>
              <td class="text-xs-left text-smaller">
                {{ props.item.type }}
              </td>
              <td class="text-xs-left text-smaller">
                {{ props.item.price }}
              </td>
              <td class="text-xs-left text-smaller">
                {{ props.item.note }}
              </td>
            </tr>
          </template>
          <template slot="pageText" slot-scope="props"
            >{{ props.itemsLength }} 件中 {{ props.pageStart }} -
            {{ props.pageStop }} 件表示</template
          >
        </v-data-table>
      </div>
    </v-layout>
    <v-btn color="green" class="white--text" @click="scrollToTop">
      <v-icon color="white">arrow_upward</v-icon>トップへ戻る
    </v-btn>
  </v-container>
</template>

<script>
import db from "@/components/firebaseInit";
import ReadTimecard from "@/components/ManageAttendance/readTimecard.vue";
import { mapGetters, mapState, mapActions } from "vuex";
import { getMoment, unixtimeToFormattedLargeTime } from "@/utils/datetime.js";
import { teamsArray } from "@/master/users.js";
import SummaryDataTooltip from "@/components/Home/summaryDataAndTooltip";
import XLSX from "xlsx";
export default {
  components: {
    ReadTimecard,
    SummaryDataTooltip,
  },
  data() {
    return {
      dbRef: db.collection("timecards"),
      dbRefUsers: db.collection("users"),
      dialog: false,
      year: 2020,
      month: 1,
      dates: [],
      timecards: [],
      items: [],
      users: {},
      years: [2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027],
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      teams: teamsArray,
      selectedTeams: teamsArray.concat(),
      selectedTimecard: {},
      dayOfWeekStr: ["日", "月", "火", "水", "木", "金", "土"],
      headers: [
        { sortable: false, width: "1%" }, //何故か1日のみテンプレートIDがクラスに入らないので特殊対応
        { text: "月",  value: "month",sortable: false, width: "3%" },
        { text: "日 *", value: "date", sortable: false, width: "3%" },
        { text: "曜日", value: "day_number", sortable: false, width: "3%" },
        { text: "S. No *", value: "staff_id", sortable: true, width: "3%" },
        { text: "名前 *", value: "owner_name", sortable: true, width: "10%" },
        { text: "チーム *", value: "owner_team", sortable: false, width: "3%" },
        {
          text: "C. No *",
          value: "client_id",
          sortable: false,
          width: "3%",
        },
        {
          text: "クライアント名 *",
          value: "client_name",
          sortable: false,
          width: "10%",
        },
        { text: "種別 *", value: "type", sortable: false, width: "9%" },
        { text: "費用", value: "price", sortable: false, width: "3%" },
        { text: "備考", value: "note", sortable: false, width: "50%" },
      ],
      pagination: {
        rowsPerPage: 50,
      },
      rowsPerPageItems: [25, 50, 100, 500],
      search: "",
      panel: [true],
    };
  },
  created() {
    const today = getMoment()();
    this.month = today.month() + 1;
    this.year = today.year();
    this.reloadItems();
  },
  mounted() {
    this.fixHeaders();
  },
  computed: {
    month_id() {
      return String(this.year) + "-" + ("0" + this.month).slice(-2);
    },
    fillteredItems() {
      if (this.CanI("ManageMyTeam")) {
        this.selectedTeams = [this.profile.team_name];
      }
      return this.items.filter((item) => {
        return this.selectedTeams.includes(item.owner_team);
      }, this);
    },
    ...mapGetters("auth", ["CanI", "isLoggedIn", "user", "profile"]),
    ...mapState("auth", ["user_type", "work_type", "team_name", "authorities"]),
  },
  watch: {
    month() {
      this.reloadItems();
    },
  },
  methods: {
    scrollToTop() {
      document.querySelector(".v-datatable tbody tr").scrollIntoView(false);
    },
    fixHeaders() {
      var elms = document.getElementsByClassName("v-table__overflow");
      elms[0].style.overflow = "visible";
    },
    async reloadItems() {
      this.changeLoadingState(true);
      const users = await this.dbRefUsers.get();
      this.users = {};
      users.forEach((doc) => {
        const user = doc.data();
        this.users[doc.id] = user;
      });
      const items = await this.dbRef
        .where("month_id", "==", this.month_id)
        .orderBy("date", "desc")
        .get();
      this.items = [];
      items.forEach((doc) => {
        const item = doc.data();
        const staffId = this.users[item.owner_id]
          ? this.users[item.owner_id].staff_id
          : "Unknown";
        item.expenses.forEach((exp) => {
          this.items.push({
            ...exp,
            id: doc.id,
            owner_name: item.owner_name,
            owner_team: item.owner_team,
            staff_id: staffId,
            month: item.month,
            date: item.date,
            day_number: item.day_number,
          });
        });
      });
      this.changeLoadingState(false);
    },
    prvMonth() {
      this.month = this.month - 1;
    },
    nextMonth() {
      this.month = this.month + 1;
    },
    dayClass(d) {
      if (d.day_number == 0 || d.is_holiday) {
        return { holiday: true };
      } else if (d.day_number == 6) {
        return { saturday: true };
      }
    },
    toDay(dayNumber) {
      return this.dayOfWeekStr[dayNumber];
    },
    getWorking(timecard) {
      return this.getTime(
        timecard.end -
          timecard.start -
          timecard.lunch -
          timecard.break -
          (timecard.total_nonworking_hours
            ? timecard.total_nonworking_hours
            : 0)
      );
    },
    getTime(unixtime) {
      return unixtimeToFormattedLargeTime(unixtime);
    },
    isEdited(timecard) {
      return timecard.isEditWorktime && timecard.isEditWorktime ? "修正" : "";
    },
    readItem(timecard) {
      this.selectedTimecard = JSON.parse(JSON.stringify(timecard));
      this.dialog = true;
    },
    getSummaryOfNote(note) {
      return note && note.length >= 25 ? note.slice(0, 25) + "..." : note;
    },
    getSummaryOfExpence(expenses) {
      let summary = "";
      expenses.forEach((expense) => {
        summary =
          summary +
          expense.client_name.replace("株式会社", "").replace("有限会社", "") +
          ": ¥" +
          expense.price +
          ", ";
      });
      summary = summary.slice(0, -2); //最後の", "を削除
      return summary.length >= 15 ? summary.slice(0, 15) + "..." : summary;
    },

    toFormattedMoney(m) {
      const money = Number(m);
      return Number.isInteger(money)
        ? "¥ " + money.toLocaleString("ja")
        : "Invalid Money :" + money;
    },
    downloadXlsxFile() {
      var FileSaver = require("file-saver");
      var workbook = { SheetNames: [], Sheets: {} };
      var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
      const header = [];
      const keys = [];
      const tableData = [];

      const sortedItems = this.fillteredItems.sort(function (a, b) {
        return (
          (Number(a.staff_id) ? Number(a.staff_id) : 0) -
          (Number(b.staff_id) ? Number(b.staff_id) : 0)
        );
      });

      this.headers.forEach((h) => {
        header.push(h.text);
        keys.push(h.value);
      });
      tableData.push(header);
      sortedItems.forEach((item) => {
        const row = [];
        keys.forEach((k) => {
          if (k == "day_number") {
            row.push(this.toDay(item[k]));
          } else {
            row.push(item[k]);
          }
        });
        tableData.push(row);
      });
      XLSX.utils.book_append_sheet(
        workbook,
        XLSX.utils.aoa_to_sheet(tableData),
        "timeTables"
      );

      var wbout = XLSX.write(workbook, wopts);
      var blob = new Blob([wbout], { type: "application/octet-stream" });
      FileSaver.saveAs(blob, "expenses.xlsx");
    },
    ...mapActions("app", ["changeLoadingState"]),
  },
};
</script>

<style lang="css" scoped>
div.pageTitle {
  font-size: 20px;
  color: #ff5722;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
div.yearMonth {
  display: inline-block;
  font-size: 20px;
  /* color: #ddd; */
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
td.holiday {
  color: #f44336;
}
td.saturday {
  color: #2196f3;
}
td.text-smaller {
  font-size: 0.8em;
}
.scroll-bar {
  overflow: auto;
}
.scroll-bar::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.scroll-bar::-webkit-scrollbar-thumb {
  background: gray;
}
.v-icon {
  margin-right: 0.3em;
}
.v-datatable th.sticky {
  background-color: white !important;
  position: -webkit-sticky;
  position: sticky;
  z-index: 1;
  top: 0;
}
</style>